export const PRODUCT_CODE_SPLITTER_CACHE_KEY = 'product_info_code_splitter';

export const PRODUCT_CODE_SPLITTER_OPTIONS = {
    space: {
        title: 'Space ( )',
        value: ' ',
    },
    comma: {
        title: 'Comma (,)',
        value: ',',
    },
    semicolon: {
        title: 'Semicolon (;)',
        value: ';',
    },
    pipe: {
        title: 'Pipe (|)',
        value: '|',
    },
    dash: {
        title: 'Dash (-)',
        value: '-',
    },
    underscore: {
        title: 'Underscore (_)',
        value: '_',
    },
    dot: {
        title: 'Dot (.)',
        value: '.',
    },
    slash: {
        title: 'Slash (/)',
        value: '/',
    },
    backslash: {
        title: 'Backslash (\\)',
        value: '\\',
    },
    colon: {
        title: 'Colon (:)',
        value: ':',
    },
};

export const DEFAULT_PRODUCT_CODE_SPLITTER = PRODUCT_CODE_SPLITTER_OPTIONS.space.value;

export const PRODUCT_CODE_SPLITTER_LIST = Object.values(PRODUCT_CODE_SPLITTER_OPTIONS);
